export default {
    name: "CustomerMasterData",
    setup(){
        
    }
}